
import React from 'react'
import Printfile from '../../components/conditionreportcomponents/Printfile'
function  Filedownload({renderPageContent}) {
    return (
        <>
                        <Printfile  renderPageContent={renderPageContent}/>
        </>
    )
}

export default Filedownload
